/**
 * Toegang kwijt tijdens het werken (401 op een aanvraag): sessie verlopen, collega gestopt of rol
 * veranderd. adminApi meldt het; AdminApp brengt je terug naar inloggen. Los bestand, zodat
 * adminApi en AdminApp niet van elkaar afhangen.
 */
const listeners = new Set<() => void>()

export function notifyAdminAccessLost() {
  listeners.forEach((l) => l())
}

export function onAdminAccessLost(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
